/**
 * @typedef {object} GeoObject
 * @property {number} id
 * @property {string} type
 */

import * as _ from 'lodash';

export default {
  /**
   * Обновляет подмножества гео фильтра определённого типа, сохраняя порядок
   * @example
   * updateSubsetOfCollectionInPlace(
   *  [{id: 1, type: 'district'}, {id: 2, type: 'district'}, {id: 1, type: 'underground'}],
   *  [{id: 2, type: 'district'}, {id: 3, type: 'district'}],
   *  'district',
   * )
   * // returns [{id: 2, type: 'district'}, {id: 1, type: 'underground'}, {id: 3, type: 'district'}]
   * // (выкинули district 1, оставили underground, добавили district 3)
   * @param {GeoObject[]} geoCollection - целевой массив, который будет мутирован
   * @param {GeoObject[]} newSubCollection - массив новых элементов
   * @param {string[]} types - список гео-типов, которые необходимо обновить
   */
  updateSubsetOfCollectionInPlace: (geoCollection, newSubCollection, types) => {
    const isProperType = item => _.includes(types, item.type);

    // Игнорируем айтемы, отличающиеся от заявленных типов
    newSubCollection = _.filter(newSubCollection, isProperType);

    // Выкидываем айтемы, которых нет в новой коллекции
    _.remove(geoCollection, item => isProperType(item) && !_.some(newSubCollection, {
        type: item.type,
        id: item.id,
      })
    );

    // Добавляем айтемы, которых не было в исходной коллекции
    geoCollection.push(..._.differenceWith(newSubCollection, geoCollection,
      (itemA, itemB) => itemA.type === itemB.type && itemA.id === itemB.id
    ));
  }
};


// WEBPACK FOOTER //
// ./src/components/common/collection-utils.js